<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'TextTruncate',
  props: {
    message: {
      type: String,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const truncatedMessage = computed(() => {
      if (!props.message) return ''
      return props.message.length > props.max ? props.message.slice(0, props.max) + '...' : props.message
    })

    return {
      truncatedMessage,
    }
  },
})
</script>

<template>
  <template v-if="message.length > max">
    <VaPopover :message="message" placement="top" :content-class="'ltr'">
      <div class="nowrap">{{ truncatedMessage }}</div>
    </VaPopover>
  </template>
  <template v-else>
    <div class="nowrap">{{ message }}</div>
  </template>
</template>
